/*
 * Shows only the selected colour's photos in the product gallery.
 *
 * Reads the colour -> media map emitted by snippets/plush-variant-media.liquid.
 * Shopify allows one image per variant, so this grouping cannot come from
 * native variant images; the map carries it instead.
 *
 * Media not listed under any colour is treated as shared and always shown, so a
 * product whose map covers only some of its photos still displays the rest.
 */
(function () {
  var optionName = null;
  var byValue = null;

  // Colour names are matched case-insensitively, so renaming an option value
  // from "MINT" to "Mint" in admin doesn't orphan its photos.
  function key(value) {
    return String(value || '').trim().toLowerCase();
  }

  // Preferred source: the groups a merchant picked in admin.
  var groups = document.querySelector('[data-plush-colour-groups]');
  if (groups) {
    optionName = groups.getAttribute('data-option');
    byValue = {};
    groups.querySelectorAll('[data-colour]').forEach(function (span) {
      var ids = (span.getAttribute('data-media') || '').split(',').filter(Boolean);
      byValue[key(span.getAttribute('data-colour'))] = ids;
    });
  } else {
    var script = document.querySelector('[data-plush-variant-media]');
    if (!script) return;
    try {
      var data = JSON.parse(script.textContent);
      // Shops where the metafield comes back as a string leave one more layer.
      if (typeof data === 'string') data = JSON.parse(data);
      var map = data.selectedImages;
      optionName = Object.keys(map)[0];
      // "gid://shopify/MediaImage/123" -> "123", matching data-media-id's tail.
      byValue = {};
      Object.keys(map).length && Object.keys(map[optionName]).forEach(function (value) {
        byValue[key(value)] = map[optionName][value].map(function (entry) {
          return String(entry.gid || '').split('/').pop();
        });
      });
    } catch (e) {
      return;
    }
  }

  if (!optionName || !byValue) return;

  function idsFor(value) {
    return byValue[key(value)] || [];
  }

  var grouped = {};
  Object.keys(byValue).forEach(function (value) {
    idsFor(value).forEach(function (id) { grouped[id] = true; });
  });

  // Slides carry data-media-id, thumbnails carry data-target; both end in the
  // media id after the section id.
  function mediaId(el) {
    var attr = el.getAttribute('data-media-id') || el.getAttribute('data-target') || '';
    return attr.split('-').pop();
  }

  function selectedValue() {
    // Dawn renders the picker as radios or as a select, depending on the setting.
    var fieldsets = document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var label = legend ? legend.textContent.trim().replace(/:.*$/, '') : '';
      if (label.toLowerCase().indexOf(optionName.toLowerCase()) !== 0) continue;
      var checked = fieldsets[i].querySelector('input:checked');
      if (checked) return checked.value;
      var select = fieldsets[i].querySelector('select');
      if (select) return select.value;
    }
    return null;
  }

  // Every item this map ever hides, so a reset can clear exactly those and
  // leave shared media alone.
  function showAllGrouped() {
    document
      .querySelectorAll('.product__media-item, .thumbnail-list__item, .product-media-modal__content > *')
      .forEach(function (el) {
        var id = mediaId(el);
        if (id && grouped[id] === true) el.hidden = false;
      });
    refreshSliders();
  }

  function apply() {
    var value = selectedValue();
    if (value === null) return;
    var allowed = idsFor(value);
    if (!allowed.length) {
      // This colour isn't in the map, so there is nothing to narrow down to.
      // Returning here used to leave the previous colour's photos hidden,
      // which showed the wrong car for the colour now selected.
      showAllGrouped();
      return;
    }

    var lookup = {};
    allowed.forEach(function (id) { lookup[id] = true; });

    var items = document.querySelectorAll(
      '.product__media-item, .thumbnail-list__item, .product-media-modal__content > *'
    );
    var firstVisible = null;

    items.forEach(function (el) {
      var id = mediaId(el);
      if (!id) return;
      // Unmapped media is shared across colours - leave it alone.
      var hide = grouped[id] === true && lookup[id] !== true;
      el.hidden = hide;
      if (!hide && !firstVisible && el.classList.contains('product__media-item')) {
        firstVisible = el;
      }
    });

    // If the slide that was showing has just been hidden, move to the first
    // photo of the colour the shopper actually picked.
    var active = document.querySelector('.product__media-item.is-active');
    if (firstVisible && (!active || active.hidden)) {
      firstVisible.scrollIntoView({ block: 'nearest', inline: 'start' });
    }

    // resetPages() measures every slide of both sliders, which is the single
    // most expensive thing this file does. Dawn re-renders the gallery a few
    // times per colour change, so apply() runs more than once; only the run
    // that actually changes which photos are visible needs to pay for it.
    var shown = visibleSignature(items);
    if (shown !== lastShown) {
      lastShown = shown;
      refreshSliders();
    }
  }

  // Cheap identity of the visible set: ids only, no layout is read.
  var lastShown = null;
  function visibleSignature(items) {
    var ids = [];
    items.forEach(function (el) {
      if (!el.hidden) ids.push(mediaId(el));
    });
    return ids.join(',');
  }

  // Dawn's SliderComponent counts its slides once (initPages keeps only items
  // with a width), so after hiding other colours its arrows and "1 / 8" counter
  // still step through photos that are no longer shown. resetPages() re-queries
  // the slides and recounts only the visible ones.
  function refreshSliders() {
    document.querySelectorAll('media-gallery slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') {
        slider.resetPages();
      } else if (typeof slider.initPages === 'function') {
        slider.initPages();
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-selects')) {
      // Dawn re-renders parts of the page on variant change; re-apply after.
      // Shares applySoon's debounce with the other two triggers, so a single
      // colour change runs apply() once rather than three times.
      applySoon();
    }
  });

  // Dawn swaps in freshly fetched gallery and zoom-modal markup some time after
  // the change event (the fetch is async), which wipes the [hidden] flags set
  // above. Re-apply once Dawn announces the variant change is rendered, and
  // watch both containers for replaced children as a fallback. Only childList
  // is observed, so the attribute changes apply() makes can't re-trigger it.
  var pending = null;
  function applySoon() {
    clearTimeout(pending);
    // 60ms, not 30: Dawn's section fetch lands a little after the change event,
    // and waiting for it means one apply() instead of one before and one after.
    pending = setTimeout(apply, 60);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, applySoon);
  }
  function observe() {
    var targets = document.querySelectorAll(
      '.product-media-modal__content, .product__media-list, .thumbnail-list'
    );
    var observer = new MutationObserver(applySoon);
    targets.forEach(function (el) { observer.observe(el, { childList: true }); });
    // A full media-gallery swap replaces the lists themselves; watch its parent.
    document.querySelectorAll('media-gallery').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); observe(); });
  } else {
    apply();
    observe();
  }
})();
